import React from 'react';
import {Map} from 'immutable';
import {lightRedBackground} from './Bootflow';
import {
  ADD_TO_CART_STATES,
  STATE,
  DATA_ATTR_NODE_TYPE,
  NODE_TYPE_COMMERCE_ADD_TO_CART_ERROR,
} from '@packages/systems/commerce/constants';
import {px} from '@packages/systems/core/utils/WebflowCssSubset';
import {TListOfElement, TRecord, TText} from '@packages/systems/wfdl-ast';
import {createIntegratedAtom} from '@packages/utilities/integrated-types';
import {Atom} from '@packages/systems/wfdl';
import {EvaluatedData} from '@packages/systems/render';
import {getChildren} from '@packages/utilities/data-utils';

const styleDisplayNone = Map({style: Map({display: 'none'})});
const CommerceAddToCartError = Atom.createRender((props) => {
  const {attributes, classes, context, data, generateAttributes, renderChild} =
    props;
  const stampedAttributes = attributes.merge({
    [DATA_ATTR_NODE_TYPE]: NODE_TYPE_COMMERCE_ADD_TO_CART_ERROR,
  });
  const styledAttributes =
    context.get(STATE) === ADD_TO_CART_STATES.ERROR
      ? stampedAttributes
      : stampedAttributes.merge(styleDisplayNone);

  return (
    <div {...generateAttributes(styledAttributes, classes)}>
      {getChildren(data).map((child: EvaluatedData) => renderChild(child))}
    </div>
  );
});

const config = createIntegratedAtom({
  showEmpty: true,
  displayName: 'Error State',
  uiStateOnSelected: ADD_TO_CART_STATES.ERROR,
  constraints: {
    pinToParent: true,
    descendants: [{is: 'CommerceAddToCartErrorMsg', rule: 'ExactlyOne'}],
  },
  style: {
    base: {
      main: {
        noPseudo: {
          marginTop: px(10),
          paddingTop: px(10),
          paddingBottom: px(10),
          paddingLeft: px(10),
          paddingRight: px(10),
          backgroundColor: lightRedBackground,
        },
      },
    },
  },
  render: CommerceAddToCartError,
  fields: {children: TListOfElement, attr: TRecord({'aria-live': TText})},
});

export default config;
